import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VBtn,_vm._g(_vm._b({staticClass:"MapPnlGrdItem elevation-5 pa-0 my-3",attrs:{"fab":"","small":""},on:{"click":function($event){return _vm.RotateToNorth()}}},'v-btn',attrs,false),on),[_c(VIcon,{style:(_vm.rotateStyle)},[_vm._v("mdi-navigation")])],1)]}}])},[_c('span',[_vm._v("Obnovit severní orientaci mapy")])])}
var staticRenderFns = []

export { render, staticRenderFns }